export default __webpack_public_path__ + "static/media/filter-arrow.2e97af5b.svg";